// Escapes user-controlled text before it is placed into a notification body, which
// NotificationContext renders via dangerouslySetInnerHTML. Names are entered by users in the green
// room, so without this they could inject markup into everyone else's snackbar (RISKS.md/P0.7).
export const escapeHtml = (s: string) =>
  s.replace(/[&<>"']/g, c => (({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string))
